/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import { criminalStoreNominal } from "../../../hooks/store";

import { ResultadoConsultaCriminal } from "../../../components";
import { LayoutConsultaCriminal } from "./LayoutConsultaCriminal";

type InputProps = {
  nome: string | undefined;
  nomeMae: string | undefined;
  nomePai: string | undefined;
};

export const FiltroCriminalNominal: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      nome: "",
      nomeMae: "",
      nomePai: "",
    },
  });

  const { user } = useAuth();

  const { url: urlCriminal } = user!.sistemas.filter((s) => {
    return s.id_sistema === 9 ? s.url : false;
  })[0];

  const {
    consultaCriminalNominal,
    mensagemCriminal,
    limparConsultaCriminalNominal,
    resultadoCriminalNominal,
  } = criminalStoreNominal((state) => state.criminal);
  const { loading } = criminalStoreNominal((state) => state.global);

  const pesquisaCriminalNominal = (data: InputProps) => {
    consultaCriminalNominal(
      urlCriminal,
      data.nome === "" ? undefined : data.nome,
      data.nomeMae === "" ? undefined : data.nomeMae,
      data.nomePai === "" ? undefined : data.nomePai
    );
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaCriminal>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCriminalNominal)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nome"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomeMae"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome da mãe"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomePai"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome do pai"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCriminalNominal}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCriminalNominal || mensagemCriminal ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCriminalNominal &&
            resultadoCriminalNominal?.map((cidadao) => (
              <ResultadoConsultaCriminal
                key={cidadao.NumeroPedido}
                infoNome={cidadao.Nome}
                infoMae={cidadao.Mae}
                infoPai={cidadao.Pai}
                to={`consulta-criminal/ficha-criminal/${cidadao.NumeroPessoa}`}
              />
            ))) || (
            <MUI.Typography variant="h6">{mensagemCriminal}</MUI.Typography>
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCriminal>
  );
};
